import { Component, HostListener, ElementRef } from '@angular/core';

import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Router, NavigationStart } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle'; // import it to your component for session checking idle
import { environment } from '../environments/environment';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
})
export class AppComponent {
	title = 'myanguler';

	showHead = true;
	sessTimeout: number;

	constructor(private router: Router, private bnIdle: BnNgIdleService) {
		// on route change to '/login', set the variable showHead to false
		router.events.forEach((event) => {
			if (event instanceof NavigationStart) {
			  // tslint:disable-next-line: triple-equals

			  var urlSegment = event.url.split("?");
			  
			  if (
			    urlSegment[0] == "/login" ||
			    urlSegment[0] == "/" ||
			    urlSegment[0] == "" ||
			    urlSegment[0] == "/forgot" ||
			    urlSegment[0] == "/verifyotp" ||
			    urlSegment[0] == "/resetpassword" ||
			    urlSegment[0] == "/faq" ||
			    urlSegment[0] == "/home" ||
			    urlSegment[0] == "/contactus" ||
			    urlSegment[0] == "/aboutus"  ||
			    urlSegment[0] =="/help-us" || 
				urlSegment[0] == "/locate-store" ||
				urlSegment[0] == "/inboundregistration" ||
				urlSegment[0] == "/outboundregistration" ||
				urlSegment[0] == "/updaterecord" ||
				urlSegment[0] == "/trackresult" ||
				urlSegment[0] == "/makepayment" ||
				urlSegment[0] == "/paymentstatuspage"||
				urlSegment[0] == "/vpassport"

				
			  ) {
			    this.showHead = false;
			  } else {
			    // console.log("NU")
			    this.showHead = true;
			  }
			}
		});

		// Session time out  if any activity not present given time(1000 Sec.)

		this.sessTimeout = environment.sessionTimeOut;

		this.bnIdle.startWatching(this.sessTimeout).subscribe((res) => {
		  if (res) {
		    console.log("session expired");
		    localStorage.clear();
		    this.router.navigate(["/login"]);
		  }
		});
	}

	onActivate(event) {
		let scrollToTop = window.setInterval(() => {
			let pos = window.pageYOffset;
			if (pos > 0) {
				window.scrollTo(0, pos - 20); // how far to scroll on each step
			} else {
				window.clearInterval(scrollToTop);
			}
		}, 16);
	}

	/* scroll top angular code */

	isShow: boolean;
	topPosToStartShowing = 100;

	@HostListener('window:scroll')
	checkScroll() {
		// window의 scroll top
		// Both window.pageYOffset and document.documentElement.scrollTop returns the same result in all the cases. window.pageYOffset is not supported below IE 9.

		const scrollPosition =
			window.pageYOffset ||
			document.documentElement.scrollTop ||
			document.body.scrollTop ||
			0;

		// console.log('[scroll]', scrollPosition);

		if (scrollPosition >= this.topPosToStartShowing) {
			this.isShow = true;
		} else {
			this.isShow = false;
		}
	}

	// TODO: Cross browsing
	gotoTop() {
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
	}

	/* scroll top last */
}

export class PhoneNumberValidator {
	static cannotContainSpace(control: AbstractControl): ValidationErrors | null {
		if ((control.value as string).indexOf(' ') >= 0) {
			return { cannotContainSpace: true };
		}

		return null;
	}
}
